import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Chip, Collapse, Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HistoryIcon from '@mui/icons-material/History';
import customsAuditService from '../../services/customsAuditService';

interface AuditHistoryProps {
  lrn?: string;
  currentScore?: number;
}

const AuditHistory: React.FC<AuditHistoryProps> = ({ lrn, currentScore }) => {
  const [expanded, setExpanded] = useState(false);
  const [history, setHistory] = useState<any[]>([]);

  useEffect(() => {
    if (lrn && expanded && history.length === 0) {
      customsAuditService.getHistoryByLrn(lrn).then(setHistory);
    }
  }, [lrn, expanded]);

  if (!lrn) return null;

  return (
    <Paper sx={{ mt: 1, borderRadius: 1.5 }}>
      <Box
        onClick={() => setExpanded(!expanded)}
        sx={{ display: 'flex', alignItems: 'center', p: 1.5, cursor: 'pointer',
              '&:hover': { bgcolor: 'action.hover' } }}
      >
        <HistoryIcon sx={{ mr: 1, fontSize: 18 }} />
        <Typography variant="subtitle2" sx={{ flex: 1 }}>Audit History</Typography>
        <ExpandMoreIcon sx={{ transform: expanded ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
      </Box>
      <Collapse in={expanded}>
        <Box sx={{ px: 1.5, pb: 1.5 }}>
          {history.length === 0 ? (
            <Typography variant="caption" color="text.secondary">No previous audits found</Typography>
          ) : (
            history.map((h, i) => (
              <Box key={h.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5,
                borderBottom: i < history.length - 1 ? '1px solid' : 'none', borderColor: 'divider' }}>
                <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80 }}>
                  {h.created_at ? new Date(h.created_at).toLocaleDateString() : '—'}
                </Typography>
                <Typography variant="body2" fontWeight={600} sx={{ minWidth: 30 }}>
                  {h.overall_risk_score}
                </Typography>
                <Chip label={(h.overall_status || '').replace('_', ' ')} size="small"
                  color={h.overall_status === 'compliant' ? 'success' : h.overall_status === 'non_compliant' ? 'error' : 'warning'} />
                <Typography variant="caption" color="text.secondary">
                  {h.finding_count} findings
                </Typography>
              </Box>
            ))
          )}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default AuditHistory;
